import { render, staticRenderFns } from "./passCard.vue?vue&type=template&id=08e3cd88&scoped=true&"
import script from "./passCard.vue?vue&type=script&lang=js&"
export * from "./passCard.vue?vue&type=script&lang=js&"
import style0 from "./passCard.vue?vue&type=style&index=0&id=08e3cd88&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./passCard.vue?vue&type=style&index=1&id=08e3cd88&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3cd88",
  null
  
)

export default component.exports